import { ChampionshipError } from '../../../endpoint/championships/championship-error';
import { ChampionshipsEndpoints } from '../../../endpoint';

export const addChallengeToChampionship = async (challengeToken: string, championshipId: string) => {
  try {
    return await ChampionshipsEndpoints.addChallengeToChampionship(challengeToken, championshipId);
  } catch (error) {
    const errorBody: ChampionshipError.ErrorWrapper = (error as any).error;
    throw errorBody;
  }
};
